import { create } from 'zustand';
import type { ConnectionState } from '../types';
import * as api from '../lib/api';

interface PresenceState {
  onlineUserIds: Record<string, boolean>;
  connectionState: ConnectionState;

  setOnlineUsers: (userIds: string[]) => void;
  userOnline: (userId: string) => void;
  userOffline: (userId: string) => void;
  setConnectionState: (state: ConnectionState) => void;
  reset: () => void;

  loadOnlineUsers: () => Promise<void>;
}

export const usePresenceStore = create<PresenceState>()((set) => ({
  onlineUserIds: {},
  connectionState: 'disconnected',

  setOnlineUsers: (userIds) => set({ onlineUserIds: Object.fromEntries(userIds.map(id => [id, true])) }),

  userOnline: (userId) => set((s) => {
    const next = { ...s.onlineUserIds };
    next[userId] = true;
    return { onlineUserIds: next };
  }),

  userOffline: (userId) => set((s) => {
    const next = { ...s.onlineUserIds };
    delete next[userId];
    return { onlineUserIds: next };
  }),

  setConnectionState: (state) => set({ connectionState: state }),

  loadOnlineUsers: async () => {
    try {
      const userIds = await api.fetchOnlineUsers();
      set({ onlineUserIds: Object.fromEntries(userIds.map(id => [id, true])) });
    } catch {
      // Ignore
    }
  },

  reset: () => set({ onlineUserIds: {}, connectionState: 'disconnected' }),
}));
